import { useState } from "react";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import api, { errMsg } from "@/lib/api";

export function ExportButton({ reportingDate, plantId, className = "" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const res = await api.get("/export/day", { params: { reporting_date: reportingDate, plant_id: plantId || undefined }, responseType: "blob" });
      const name = (res.headers["content-disposition"] || "").match(/filename=([^;]+)/)?.[1] || `PlantPulse_${reportingDate}.xlsx`;
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url);
      toast.success(`Exported ${name}`);
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  return <button className={`pp-btn-ghost h-9 px-3 ${className}`} onClick={run} disabled={busy} data-testid="export-day-btn"><FileDown size={14} /> {busy ? "Exporting…" : "Export Excel"}</button>;
}
